<script>
    import { createEventDispatcher } from 'svelte';
    import { toasts } from "./stores.js";
    import Select from "svelte-select";

    export let fundTitle = "";
    export let fundId = ""

	const dispatch = createEventDispatcher();
    $: reasons = [
        {value: null, label: "Select Report Reason..."},
        {value: 1, label: "Fundraiser Funds Illegal Acitvity"},
        {value: 2, label: "Fundraiser is Duplicate of Another Fund"},
        {value: 3, label: "Fundraiser Advertises Alternative BTC Address"}
    ]

    $: reportReason = "Select Report Reason...";
    $: reportSelection = null

    const handleSelect = e => {
        reportReason = e.detail;
        reportSelection = e.value;
    }

    const handleReport = () => {
        if (reportSelection == null) {toasts.pushToast("select a reason", "error"); return}
        fetch(
            "http://172.81.181.23:3004/report?fund_id=" + fundId + "&reason=" + reportSelection,
            {
                method: "POST",
                headers: {
                    "Authorization": "Basic womp",
                }
            }
        )
        .then(res => {
            dispatch("close");
            if (res.status != 200) {
                toasts.pushToast("error reporting", "error");
                return
            }
            toasts.pushToast("report successful", "success");
        })
    }

</script>

<div class="container">
    <h1 >Report {fundTitle}</h1>
    <div class="custom-select">
        <select bind:value={reportSelection}>
            {#each reasons as r}<option value={r.value}>{r.label}</option>{/each}
        </select>
    </div>
    <div class="close">
        <button 
            on:click={() => dispatch('close')}
            class="b link dim br2 ph3 pv2 mb2 dib white bg-brand-red"
        >
        Cancel
        </button>
        <button 
            style="margin-left: 2rem;"
            on:click={handleReport}
            class="b link dim br2 ph3 pv2 mb2 dib white bg-brand-green"
        >
        Report
        </button>
    </div>
</div>

<style>
    .custom-select {
        margin-bottom: 1rem;
        width: calc(100% - 2rem);
    }
    .custom-select > select {
        padding: 0.6rem;
        width: 100%;
        background-color: white;
        color: #232C33;
    }
    .custom-select > select > option{
        padding: 0.6rem;
        background-color: white;
        color: #232C33;
    }

    .container {
        background-color: white;
        -webkit-box-shadow: 3px 6px 22px 0px rgba(0,0,0,0.75);
        -moz-box-shadow: 3px 6px 22px 0px rgba(0,0,0,0.75);
        box-shadow: 3px 6px 22px 0px rgba(0,0,0,0.75);

        border-radius: 1rem;

        padding: 1rem;

        display: flex;
        flex-direction: column;
        align-items: center;

        width: calc(100vw - 4rem);
        height: fit-content;

        margin-left: 1rem;
        margin-right: 1rem;
    }
    @media only screen and (min-width: 768px) {
        .container { 
            width: fit-content;
            width: -moz-fit-content;
            height: fit-content;
            height: -moz-fit-content;
        }
    }
    .cancel-button {
        background-color: #F25F5C !important;
    }
</style>
